
// export const imageURL = 'http://localhost:5046/uploads/ledgers';
// export const imageURL = 'https://girvibackend.prakash-n-co.in/uploads/ledgers';
export const imageURL = 'https://girvibackend.grjewellers.in/uploads/ledgers';
// export const imageURL = 'https://sashigirvibackend.riddhi-infotech.com/uploads/ledgers';
